import { PublishModal } from '@diagram/components/diagram-sidebar/sidebars/share-diagram/components/PublishModal';
import { AIInspirationModal } from '@diagram/modals/AIInspirationModal';
import { AskCompany } from '@diagram/modals/AskCompany';
import { ChannelAccess } from '@diagram/modals/ChannelAccess';
import { ConnectingWithCompany } from '@diagram/modals/ConnectingWithCompany';
import { CreateChatChannel } from '@diagram/modals/CreateChatChannel';
import { CreateReusableComponent } from '@diagram/modals/CreateReusableComponent';
import { ExportDiagramModal } from '@diagram/modals/ExportDiagramModal';
import { ForceRefreshModal } from '@diagram/modals/ForceRefreshModal';
import { ImageSizeModal } from '@diagram/modals/ImageSizeModal';
import { InviteCompany } from '@diagram/modals/InviteCompany';
import { SignOffInvite } from '@diagram/modals/SignOffInvite';
import { UpdateChatChannel } from '@diagram/modals/UpdateChatChannel';
import { ZoneDroopCurvesModal } from '@diagram/modals/ZoneDroopCurvesModal';

import { companyProfileModals } from 'components/company-profile-edit/modals';
import { InstallationMethodInfoModal } from 'components/component-fields/InstallationMethodInfoModal';
import { AIAccessModal } from 'components/modals/AIAccessModal';
import { CompanySuggestionsModal } from 'components/modals/CompanySuggestionsModal';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { CreateTeamModal } from 'components/modals/CreateTeamModal';
import { DeviceTypeModal } from 'components/modals/DeviceTypeModal';
import { InfoModal } from 'components/modals/InfoModal';
import { LoginModal } from 'components/modals/LoginModal';
import { NameModal } from 'components/modals/NameModal';
import { SwitchTeamModal as GenericSwitchTeamModal } from 'components/modals/SwitchTeamModal';
import { TeamSuggestionsModal } from 'components/modals/TeamSuggestionsModal';
import { WireSizeSettingsModal } from 'components/modals/WireSizeSettingsModal';
import { FeatureLimitTrackerModal } from 'components/subscriptions/FeatureLimitTrackerModal';
import { PricingExitFeedbackModal } from 'components/subscriptions/pricing-page/PricingExitFeedbackModal';
import { SimpleSubscriptionModal } from 'components/subscriptions/SimpleSubscriptionModal';

import { TeamNameRequiredModal } from './TeamNameRequiredModal';

const modals = {
    aiAccess: AIAccessModal,
    aiInspiration: AIInspirationModal,
    askCompany: AskCompany,
    channelAccess: ChannelAccess,
    companySuggestions: CompanySuggestionsModal,
    connectingWithCompany: ConnectingWithCompany,
    createChatChannel: CreateChatChannel,
    createReusableComponent: CreateReusableComponent,
    createTeam: CreateTeamModal,
    deviceType: DeviceTypeModal,
    exportDiagram: ExportDiagramModal,
    featureLimitTracker: FeatureLimitTrackerModal,
    forceRefresh: ForceRefreshModal,
    genericSwitchTeam: GenericSwitchTeamModal,
    infoModal: InfoModal,
    installationMethodInfo: InstallationMethodInfoModal,
    imageSize: ImageSizeModal,
    inviteCompany: InviteCompany,
    login: LoginModal,
    publishDesign: PublishModal,
    pricingExitFeedback: PricingExitFeedbackModal,
    name: NameModal,
    confirmation: ConfirmationModal,
    signOffInvite: SignOffInvite,
    simpleSubscriptionModal: SimpleSubscriptionModal,
    teamNameRequired: TeamNameRequiredModal,
    teamSuggestions: TeamSuggestionsModal,
    updateChatChannel: UpdateChatChannel,
    zoneDroopCurves: ZoneDroopCurvesModal,
    ...companyProfileModals,
    wireSizeSettings: WireSizeSettingsModal,
};

export { modals };
